import React from "react";
import { Dialog, DialogContent } from "@mui/material";
import "../css/AppExitPopup.css";
import { useLogout } from "services/LogoutProvider";
import { STRING } from "utils/strings";

const AppExitPopup: React.FC = () => {
  const { showAppExitPopup, setShowAppExitPopup, handleAppExitConfirm } =
    useLogout();
  return (
    <Dialog
      open={showAppExitPopup}
      onClose={() => setShowAppExitPopup(false)}
      PaperProps={{
        className: "app-exit-popup-container",
      }}
    >
      <DialogContent sx={{ padding: 0, margin: 0 }}>
        <div>
          <div className="app-exit-header-container">
            <div className="app-exit-header-text-container">
              <div className="app-exit-header-container-text">
                {STRING.APP_EXIT_POPUP_TITLE}
              </div>
            </div>

            <div className="app-exit-header-container-divider"></div>
            <div className="app-exit-header-button-container">
              <div
                className="app-exit-header-container-button"
                onClick={() => setShowAppExitPopup(false)}
              >
                ✕
              </div>
            </div>
          </div>
          <div className="app-exit-divider"></div>
          <div className="app-exit-popup-content">
            <p>{STRING.APP_EXIT_POPUP_MESSAGE}</p>
            <button
              className="app-exit-popup-content-button"
              onClick={handleAppExitConfirm}
            >
              {STRING.APP_EXIT_POPUP_BUTTON}
            </button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default AppExitPopup;
